import React from 'react'
import Avatar from 'react-avatar'

const AvatarButton= ({imageUrl, name}) => {
    return (
        <Avatar src={imageUrl} name={name} size={40} round="20px"/>
    )
}

export default React.memo(AvatarButton)